import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const GlosaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='GLOSA' htmlFor='textarea-glosa' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='glosa'>
          {({ field }) => (
            <Form.TextArea
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              rows='2'
              id='textarea-glosa'
              placeholder='Ingresar glosa ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(GlosaFormGroup)
